import React, { useContext } from 'react';
import { AppConfigContext } from '@providers/AppConfigProvider';

type ErrorImageProps = {
  alt: string;
  className: string;
  width: string | number;
  height: string | number;
  onError: (event: React.SyntheticEvent<HTMLImageElement>) => void;
};

export default function ErrorImage({
  alt,
  className = '',
  width = 'auto',
  height = 'auto',
  onError,
}: ErrorImageProps): React.JSX.Element {
  const { assetUrlPrefix } = useContext(AppConfigContext);

  return (
    <img
      src={`${assetUrlPrefix}karte/common/image-process-error.jpg.webp`}
      alt={alt}
      className={className}
      width={width}
      height={height}
      onError={onError}
    />
  );
}
